import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Oncologist icon
 *
 * @category Medical
 */
const Oncologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M5.656 13.624c-.023 2.495.942 5.012 2.735 6.748.403.39 1.368 1.069 1.391 1.62.012.552-.954.748-1.448 1-.494.253-1.54.84-2 1.15-1.207.805-.84 2.23.034 3.391s2.46 1.61 3.886 1.414c1.655-.218 3.77-1.885 5.126-2.736.53-.322 1.31.356 2.242.747 1.138.472 2.276 1.426 3.448 1.782 1.357.414 2.943.287 4.046-.598s1.552-2.62.76-3.805c-.553-.827-1.53-1.241-2.438-1.666-.23-.115-1.069-.334-1.184-.564-.172-.344.471-.735.724-1.034.598-.724 1.196-1.219 1.713-1.885 1.23-1.598 1.782-3.667 1.678-5.679-.103-2.011-.827-3.965-1.93-5.667-1.104-1.712-2.633-3.207-4.484-4.046-1.873-.85-4.034-1-6.034-.506-2 .495-3.828 1.61-5.242 3.104-1.782 1.874-2.92 4.38-3.023 6.966v.276zm18.139 5.127c-.426.552-1.851 2.448-3.196 2.793-.62.15-1.218-.31-1.747-.609-.506-.322-1.15-.598-1.552-1.058-.161-.298-.184-.563.103-.839 1.012-.92 2.07-1.804 2.932-2.873.965-1.012 1.609-2.265 2.126-3.552.253-.633.402-1.31.598-1.966.126-.437.299-1.736.908-1.494.529.218.828 1.448.989 1.942.275.851.379 1.76.367 2.656-.034 1.666-.47 3.517-1.448 4.897l-.069.091zm-11.403-3.598c-1.403-4.23 4.287-7.885 6.793-3.655 1.08 1.965.713 4.322-.988 5.655-.954.908-1.99 1.644-2.966 1.058-1.07-.713-2.242-1.69-2.77-2.851zm9.15-9.023c1.275 1.793 1.057 4.023.011 6.494-.093.22-.228.514-.356.788-.098.211-.419.156-.45-.075a7 7 0 0 0-.125-.69c-.724-2.759-3.357-4.529-5.931-3.655-1.476.495-2.927 2.254-3.145 4.07-.028.234-.388.36-.56.198a.5.5 0 0 0-.077-.061C5.978 5.497 15.967.658 21.427 6.015l.103.126zm-11.3 21.966c-1.356.437-4.31-1.483-3.448-3.069.62-.931 1.862-1.126 2.804-1.655.54-.253 1.092-.552 1.69-.575.632.035 1.173.62 1.724.989.621.505 1.403.77 1.851 1.402.161.38-.529.724-1.057 1.07-.966.585-2.54 1.413-3.426 1.792l-.15.046zm14.553-.908a2.2 2.2 0 0 1-.368.368 3.22 3.22 0 0 1-2.678.667c-.656-.138-1.242-.472-1.817-.805-2.563-1.506-5.023-3.184-7.402-4.966-1.713-1.276-3.426-2.655-4.506-4.494-1.472-2.506-1.575-5.748-.276-8.345.609-1.219 1.011.356 1.16.954.805 3.299 3.012 6.126 5.645 8.264s5.69 3.69 8.724 5.22c.449.229.908.459 1.288.804.379.345.655.816.643 1.322 0 .379-.172.735-.402 1.023z"
        />
      </svg>
    );
  }
);

Oncologist.displayName = 'Oncologist';

export { Oncologist };
